/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Pdf_InvalidInputs */

const en_conversion_error_pdf_invalid = /** @type {(inputs: Conversion_Error_Pdf_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unable to read this PDF document.`)
};

const es_conversion_error_pdf_invalid = /** @type {(inputs: Conversion_Error_Pdf_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede leer este documento PDF.`)
};

/**
* | output |
* | --- |
* | "Unable to read this PDF document." |
*
* @param {Conversion_Error_Pdf_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_pdf_invalid = /** @type {((inputs?: Conversion_Error_Pdf_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Pdf_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_pdf_invalid(inputs)
	return en_conversion_error_pdf_invalid(inputs)
});